import { MemoryStorage, SaveStore, type KeyValueStorage } from '../meta/save/store';

/**
 * Web key-value storage (localStorage). Falls back to memory when storage is blocked (private
 * mode, sandboxed frames) so the game still runs; progress just won't persist. Native builds will
 * swap in Capacitor Preferences, as lawnmower's src/platform/storage.ts does.
 */
function createWebStorage(): KeyValueStorage {
  try {
    const probe = '__bm_probe__';
    window.localStorage.setItem(probe, '1');
    window.localStorage.removeItem(probe);
  } catch {
    return new MemoryStorage();
  }
  return {
    get: (key) => {
      try {
        return window.localStorage.getItem(key);
      } catch {
        return null;
      }
    },
    set: (key, value) => {
      try {
        window.localStorage.setItem(key, value);
      } catch {
        // Quota or permission error: keep playing; the next write may succeed.
      }
    },
  };
}

let store: SaveStore | null = null;

/** The player's save, shared by every scene. */
export function saveStore(): SaveStore {
  store ??= new SaveStore(createWebStorage());
  return store;
}
